<template>
  <section id="offer" class="py-10 md:py-16">
    <div class="container mx-auto px-4">
      <h2 class="text-3xl font-bold text-center mb-8">
        {{ t('whyUs.title') }}
      </h2>
      <div class="w-24 h-1 bg-leaf mx-auto mb-6 rounded-full"></div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div class="text-center">
          <div class="text-5xl mb-4 flex justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
            >
              <path
                fill="none"
                stroke="#a6da95"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4.389 10.167h7.222v2.889a1.444 1.444 0 0 1-1.444 1.444H5.833a1.444 1.444 0 0 1-1.444-1.444ZM8 5.833A4.333 4.333 0 0 0 3.667 1.5H1.5v1.444a4.333 4.333 0 0 0 4.333 4.334H8m0 0a4.333 4.333 0 0 1 4.333-4.334H14.5v.723A4.333 4.333 0 0 1 10.167 8H8m0 2.167V5.833"
                stroke-width="1"
              />
            </svg>
          </div>
          <h3 class="font-semibold mb-2">{{ t('whyUs.natural') }}</h3>
          <p class="text-muted-foreground">{{ t('whyUs.naturalDesc') }}</p>
        </div>
        <div class="text-center">
          <div class="text-5xl mb-4 flex justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 36 36"
            >
              <path fill="#ccd6dd" d="M11 11h3v9h-3z" />
              <path
                fill="#77b255"
                d="M24 26.157C24 28.832 22.354 31 20.325 31H4.709c-2.029 0-3.488-1.565-3.258-3.494l.625-5.241c.23-1.93 1.992-3.808 3.928-4.199l14.628-3.21C22.496 14.413 24 16.219 24 18.893z"
              />
              <path
                fill="#292f33"
                d="M16.535 24.167C16.239 26.283 17.791 28 20 28h9c2.209 0 4-1.717 4-3.833V8.833C33 6.716 31.547 5 29.755 5h-7.303c-1.792 0-3.484 1.716-3.78 3.833z"
              />
              <path
                fill="#bbddf5"
                d="M18.245 25c-.135 1.104.65 2 1.755 2h9a2 2 0 0 0 2-2V11c0-1.104-.743-2-1.66-2h-7.473c-.917 0-1.771.896-1.906 2z"
              />
              <path fill="#77b255" d="M15 21h18v10H15z" />
              <path fill="#ffcc4d" d="M33 23H2l1-2h30z" />
              <circle cx="8" cy="31" r="4" fill="#292f33" />
              <circle cx="8" cy="31" r="2" fill="#ffcc4d" />
              <path fill="#77b255" d="M33 16v4l-10 9l-7-1l3-10l3-2z" />
              <path
                fill="#292f33"
                d="M18.222 26.111a8.89 8.89 0 0 1 8.889-8.889A8.89 8.89 0 0 1 36 26.111A8.89 8.89 0 0 1 27.111 35a8.89 8.89 0 0 1-8.889-8.889"
              />
              <path
                fill="#ffcc4d"
                d="M32.667 26.111a5.556 5.556 0 1 1-11.112 0a5.556 5.556 0 0 1 11.112 0"
              />
              <path
                fill="#ffe8b6"
                d="M30.444 26.111a3.333 3.333 0 1 1-6.667 0a3.333 3.333 0 1 1 6.667 0"
              />
              <path
                fill="#77b255"
                d="M32.588 7c-.552-1.187-1.606-2-2.833-2h-7.303c-1.227 0-2.395.813-3.112 2z"
              />
              <path
                fill="#f4900c"
                d="M29.333 26.111a2.222 2.222 0 1 1-4.444 0a2.222 2.222 0 0 1 4.444 0"
              />
              <circle cx="8" cy="31" r="1" fill="#f4900c" />
              <path fill="#66757f" d="M11 13h3v2h-3z" />
              <path
                fill="#5c913b"
                d="M16 28.75q-.142 0-.285-.041a1 1 0 0 1-.675-1.243l2-6.75C17.421 18.796 19.188 15 23 15h10a1 1 0 1 1 0 2H23c-3.144 0-4.011 4.154-4.02 4.196l-2.021 6.838a1 1 0 0 1-.959.716"
              />
              <path
                fill="#3e721d"
                d="M2.001 29q-.062 0-.125-.008a1 1 0 0 1-.868-1.116l1-8a1 1 0 1 1 1.984.248l-1 8a1 1 0 0 1-.991.876"
              />
            </svg>
          </div>
          <h3 class="font-semibold mb-2">{{ t('whyUs.local') }}</h3>
          <p class="text-muted-foreground">{{ t('whyUs.localDesc') }}</p>
        </div>
        <div class="text-center">
          <div class="text-5xl mb-4 flex justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 128 128"
            >
              <path
                fill="#3f51b5"
                d="M21.1 23.79c-.46.11-2.08-1.23-7.01-.76c-1.87.18-2.55.66-2.55.66s.18-2.66 2.42-4.45c1.57-1.26 3.01-1.75 4-1.94c.71-.14 1.16-.81 1.05-1.53c-.27-1.71-.32-4.52 1.83-5.95c2.02-1.35 4.19-.42 5.52.46c.66.44 1.54.23 1.92-.48c.5-.94 1.33-2.17 2.62-3.17c2.51-1.94 4.85-.62 4.85-.62s-2.15 1.86-2.25 6.6c-.01.52.19 1.82-.09 2.28c-3.28 2.33-5.38 4.13-8.66 6.47c-1.37.98-1.75 1.24-3.14 2.19c-.18.13-.35.2-.51.24"
              />
              <circle cx="43.83" cy="39.44" r="30.22" fill="#3f51b5" />
              <path
                fill="#303f9f"
                d="M61.17 14.69c1.58 3.03 4.1 5.07 2.28 14.8c-1.41 7.54-7.71 15.42-20.65 16.26c-11.01.71-18.79-5.3-21.02-12.6c-2.12-6.94-.87-12.82 3.53-17.6c-11.22 7.48-11.7 20.41-11.7 23.88c0 16.69 13.53 30.22 30.22 30.22s30.22-13.53 30.22-30.22c.01-10.23-5.09-19.28-12.88-24.74"
              />
              <circle cx="90.39" cy="59.75" r="33.12" fill="#5064c9" />
              <path
                fill="#4054b0"
                d="M123.47 61.06c-5.69 14.41-18.79 25.92-39.19 19.6c-16.67-5.17-25.41-25-20.49-40.55a33 33 0 0 0-4.83 9.49c-5.56 17.42 4.02 36.05 21.41 41.6s36-4.07 41.56-21.49c.91-2.87 1.41-5.77 1.54-8.65"
              />
              <path
                fill="#8092f2"
                d="M100.36 46.17s3.48 8 9.12 6.08c3.38-1.15 2.5-6.79 2.5-6.79s8.99-.41 8.58-4.36c-.42-4.05-6.07-5.37-6.07-5.37s-.49-5.85-2.51-7.4c-3.37-2.57-7.56 1.42-7.56 1.42s-3.23-5.41-8.11-4.36c-3.91.84-1.77 9.2-1.77 9.2s-5.66-.07-3.31 4.58c2.57 5.1 9.13 7 9.13 7"
              />
              <ellipse
                cx="104.42"
                cy="39.16"
                fill="#2f3e82"
                rx="6.45"
                ry="7.34"
                transform="rotate(-63.294 104.415 39.165)"
              />
              <ellipse
                cx="103.87"
                cy="40.17"
                fill="#5064c9"
                rx="5.52"
                ry="6.36"
                transform="rotate(-55.82 103.867 40.165)"
              />
              <circle cx="38.67" cy="88.24" r="34.18" fill="#6678d9" />
              <path
                fill="#5366cf"
                d="M70.98 77.09c.19 1.32.67 35.28-33.79 36.26c-14.12.4-23.69-8.91-28.13-19.59C4.5 82.79 9.9 69.8 9.9 69.8s-2.89 4.66-3.53 7.29c-1.21 3.5-1.87 7.25-1.87 11.15c0 18.88 15.3 34.18 34.18 34.18s34.18-15.3 34.18-34.18c-.01-3.91-.68-7.66-1.88-11.15"
              />
              <path
                fill="#9aa7ed"
                d="M35.42 81.76s-4.05 7.91-11.4 5.77c-3.4-.99-1.81-6.31-1.81-6.31s-4.75-.39-6.47-4.48c-1.54-3.66 6.7-5.12 6.7-5.12s-3.26-6 .19-8.42s7.21 3.02 7.21 3.02s3.07-8.86 7.06-5.93c3.82 2.81 2.85 10.91 2.85 10.91s6.88 1.16 4.56 5.81c-2.56 5.12-8.89 4.75-8.89 4.75"
              />
              <ellipse
                cx="30.2"
                cy="75.16"
                fill="#2c3f9e"
                rx="7.77"
                ry="7.17"
                transform="rotate(-12.285 30.206 75.172)"
              />
              <ellipse
                cx="31.42"
                cy="75.7"
                fill="#5366cf"
                rx="6.57"
                ry="6.3"
                transform="rotate(-12.285 31.43 75.709)"
              />
            </svg>
          </div>
          <h3 class="font-semibold mb-2">{{ t('whyUs.direct') }}</h3>
          <p class="text-muted-foreground">{{ t('whyUs.directDesc') }}</p>
        </div>
        <div class="text-center">
          <div class="text-5xl mb-4 flex justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 128 128"
            >
              <path
                fill="#f44336"
                d="M93.99 8.97c-21.91 0-29.96 22.39-29.96 22.39s-7.94-22.39-30-22.39c-16.58 0-35.48 13.14-28.5 43.01s58.56 67.08 58.56 67.08s51.39-37.21 58.38-67.08c6.98-29.87-10.56-43.01-28.48-43.01"
              />
              <path
                fill="#c33"
                d="M30.65 11.2c17.2 0 25.74 18.49 28.5 25.98c.39 1.07 1.88 1.1 2.33.06L64 31.35C60.45 20.01 50.69 8.97 34.03 8.97c-6.9 0-14.19 2.28-19.86 7.09c5.01-3.29 10.88-4.86 16.48-4.86m63.34-2.23c-5.29 0-10.11 1.15-13.87 3.47c2.64-1.02 5.91-1.24 9.15-1.24c16.21 0 30.72 12.29 24.17 40.7c-5.62 24.39-38.46 53.98-48.49 65.27c-.64.72-.86 1.88-.86 1.88s51.39-37.21 58.38-67.08c6.98-29.86-10.53-43-28.48-43"
              />
              <path
                fill="#ff8a80"
                d="M17.04 24.82c3.75-4.68 10.45-8.55 16.13-4.09c3.07 2.41 1.73 7.35-1.02 9.43c-4 3.04-7.48 4.87-9.92 9.63c-1.46 2.86-2.34 5.99-2.79 9.18c-.18 1.26-1.83 1.57-2.45.46c-4.22-7.48-5.42-17.78.05-24.61m60.12 9.84c-1.76 0-3-1.7-2.36-3.34c1.19-3.02 2.73-5.94 4.58-8.54c2.74-3.84 7.95-6.08 11.25-3.75c3.38 2.38 2.94 7.14.57 9.44c-5.09 4.93-11.51 6.19-14.04 6.19"
              />
            </svg>
          </div>
          <h3 class="font-semibold mb-2">{{ t('whyUs.health') }}</h3>
          <p class="text-muted-foreground">{{ t('whyUs.healthDesc') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
